module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-video-item-inner">\n  ';
 if (videoStyle === 'thumb') { 
__p+='\n    <div class="fmcy-video-item-image-wrapper">\n      <div class="fmcy-video-item-image fmcy-video-item-image-thumb fmcy-video-item-image-region"></div>\n      <div class="fmcy-video-play-button"></div>\n    </div>\n    <div class="fmcy-video-item-title">'+
((__t=( name ))==null?'':__t)+
'</div>\n    <div class="fmcy-video-item-description">'+
((__t=( description ))==null?'':__t)+
'</div>\n  ';
 } else { 
__p+='\n    <div class="fmcy-video-item-title">'+
((__t=( name ))==null?'':__t)+
'</div>\n    <div class="fmcy-video-item-description">'+
((__t=( description ))==null?'':__t)+
'</div>\n    <div class="fmcy-video-item-image-wrapper ">\n      <div class="fmcy-video-item-image fmcy-video-item-image-large fmcy-video-item-image-region"></div>\n      <div class="fmcy-video-play-button"></div>\n    </div>\n  ';
 }
__p+='\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/video-group/video-item/video-item.html
 ** module id = 451
 ** module chunks = 1 16 107 119 152
 **/